import { render, staticRenderFns } from "./NoticeIcon.vue?vue&type=template&id=0b582eb7&scoped=true"
import script from "./NoticeIcon.vue?vue&type=script&lang=js"
export * from "./NoticeIcon.vue?vue&type=script&lang=js"
import style0 from "./NoticeIcon.vue?vue&type=style&index=0&id=0b582eb7&prod&lang=css&scoped=true"
import style1 from "./NoticeIcon.vue?vue&type=style&index=1&id=0b582eb7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b582eb7",
  null
  
)

export default component.exports